<template>
  <v-form ref="addEditCardHolderForm" v-model="valid">
    <v-dialog
      v-model="editAddDialog"
      max-width="800px"
      persistent
      fullscreen
      hide-overlay
      v-if="cardholder != null"
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark :class="{ secondary: !$vuetify.theme.dark }">
          <v-btn icon dark @click="closeAddEditCardHolderDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ addEditDialogTitle }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text v-on:saved="dialog = false" @click="onSave">
              <template v-if="addEditDialogState == 'add'">
                <v-icon class="mr-2">mdi-send mdi-rotate-315</v-icon> Issue Card
              </template>
              <template> <v-icon class="mr-2">save</v-icon> Save </template>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text class="mt-5">
          <v-row>
            <v-col cols="12" md="8" lg="6">
              <v-row>
                <v-col cols="12" md="6" xl="4" class="my-0 py-0">
                  <v-text-field
                    :validate-on-blur="isFirstSubmissionAttempt"
                    :rules="nameRules"
                    label="First Name"
                    required
                    outlined
                    dense
                    v-model="cardholder.firstName"
                    class="text-transform-capitalize"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6" xl="4" class="my-0 py-0">
                  <v-text-field
                    :validate-on-blur="isFirstSubmissionAttempt"
                    :rules="nameRules"
                    label="Last Name"
                    required
                    outlined
                    dense
                    v-model="cardholder.lastName"
                    class="text-transform-capitalize"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="4" md="2" xl="1" class="my-0 py-0">
                  <v-autocomplete
                    v-model="selectedTelephoneCode"
                    label="Country"
                    required
                    outlined
                    dense
                    :items="telephoneCodes"
                    item-text="countryCode"
                    item-value="countryCode"
                    return-object
                    :filter="filterTelephoneCodeAutocompleteBox"
                  >
                    <template slot="item" slot-scope="data">
                      {{ data.item.name }} ({{ data.item.countryCode }})
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="8" md="4" xl="3" class="my-0 py-0">
                  <v-text-field
                    :prefix="selectedTelephoneCode.number"
                    placeholder=" "
                    :validate-on-blur="isFirstSubmissionAttempt"
                    v-mask="mobileMask"
                    :rules="mobileRules"
                    label="Mobile"
                    required
                    outlined
                    dense
                    v-model="cardholder.mobile"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6" xl="4" class="my-0 py-0">
                  <v-text-field
                    :validate-on-blur="isFirstSubmissionAttempt"
                    label="Email"
                    required
                    outlined
                    dense
                    v-model="cardholder.email"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" xl="8" class="my-0 py-0">
                  <v-text-field
                    :validate-on-blur="isFirstSubmissionAttempt"
                    :rules="nameRules"
                    label="Job Title"
                    required
                    outlined
                    dense
                    v-model="cardholder.jobTitle"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" xl="12" class="my-0 py-0 mb-5">
                  <div class="text-body-1 text--primary font-weight-medium">
                    Individual Team Member Permissions
                  </div>
                  <div class="text-body-2">
                    Turn toggle/radio buttons On or Off to enable your team
                    member to attach additional information to their business
                    card. When ready, click Issue Card button in the top right
                    hand corner of your screen to issue the business card to
                    your team member.
                  </div>
                </v-col>
                <v-col cols="12" sm="12" xl="12" class="my-0 py-0">
                  <v-switch
                    class="my-0 py-1"
                    label="Disable card sharing"
                    v-model="cardholder.disableCardSharing"
                  ></v-switch>
                </v-col>
              </v-row>
              <v-row
                v-if="
                  addEditDialogState == 'add' || cardholder.status == 'Pending'
                "
              >
                <v-col cols="12" sm="12" xl="12" class="my-0 py-0">
                  <v-switch
                    class="my-0 py-1"
                    label="Auto-connect to all other team members on card acceptance"
                    v-model="cardholder.autoConnectToOthers"
                  ></v-switch>
                </v-col>
              </v-row>

              <template v-if="hasPermissions">
                <v-row>
                  <v-col cols="12" sm="12" xl="12" class="my-0 py-0">
                    <v-switch
                      class="my-0 py-1"
                      label="Enable this team member to add their LinkedIn Handle"
                      v-model="cardholder.permissions.linkedin"
                    ></v-switch>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" xl="12" class="my-0 py-0">
                    <v-switch
                      class="my-0 py-1"
                      label="Enable this team member to add Qualifications and Professional Organisation Accreditation"
                      v-model="cardholder.permissions.qualifications"
                    ></v-switch>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" xl="12" class="my-0 py-0">
                    <v-switch
                      class="my-0 py-1"
                      label="Enable this team member to add their own Facebook URL"
                      v-model="cardholder.permissions.facebook"
                    ></v-switch>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" xl="12" class="my-0 py-0">
                    <v-switch
                      class="my-0 py-1"
                      label="Enable this team member to add their own Instagram Handle"
                      v-model="cardholder.permissions.instagram"
                    ></v-switch>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" xl="12" class="my-0 py-0">
                    <v-switch
                      class="my-0 py-1"
                      label="Enable this team member to add their own Twitter Handle"
                      v-model="cardholder.permissions.twitter"
                    ></v-switch>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" xl="12" class="my-0 py-0">
                    <v-switch
                      class="my-0 py-1"
                      label="Enable this team member to add an additional address"
                      v-model="cardholder.permissions.address"
                    ></v-switch>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" xl="12" class="my-0 py-0">
                    <v-switch
                      class="my-0 py-1"
                      label="Enable this team member to add an additional URL"
                      v-model="cardholder.permissions.additionalWebsite"
                    ></v-switch>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" xl="12" class="my-0 py-0">
                    <v-switch
                      class="my-0 py-1"
                      label="Enable this team member to add an additional phone number"
                      v-model="cardholder.permissions.additionalPhoneNumber"
                    ></v-switch>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" xl="12" class="my-0 py-0">
                    <v-switch
                      class="my-0 py-1"
                      label="Enable this team member to add an additional email address"
                      v-model="cardholder.permissions.additionalEmail"
                    ></v-switch>
                  </v-col>
                </v-row>
              </template>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-form>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import {updateBusinessCardsDoc} from "@/shared/firebase_utils";
export default {
  props: {
    addEditDialogTitle: { type: String, default: "Edit Team Member" },
    addEditDialogState: { type: String, default: "edit" },
    businessCard: {
      type: Object,
      default: function () {
        return {};
      },
    },
    show: { type: Boolean, default: false },
  },
  created() {
    if (this.businessCard != null && this.businessCard != undefined) {
      this.cardholder = this.businessCard;
    }
  },
  watch: {
    businessCard: function (newValue) {
      if (newValue != null && newValue != undefined) {
        this.cardholder = newValue;
      }
    },
    show: function (newValue) {
      this.editAddDialog = newValue;
    },
  },
  data() {
    return {
      valid: false,
      editAddDialog: false,
      isFirstSubmissionAttempt: true,
      nameRules: [(v) => !!v || "This field is required"],
      selectedTelephoneCode: {
        name: "Australia",
        number: "+61",
        countryCode: "AU",
      },
      mobileRules: [
        (v) => !!v || "This field is required",
        (v) => /^\d+$/.test(v.replaceAll(" ", "")) || "Invalid mobile number",
      ],
      cardholder: null,
    };
  },
  computed: {
    ...mapGetters(["telephoneCodes"]),
    mobileMask() {
      if (this.selectedTelephoneCode.countryCode == "AU")
        return "W## ### ######";
      else return "### ### ######";
    },
    hasPermissions() {
      return this.cardholder.permissions ? true : false;
    },
  },
  methods: {
    ...mapActions(["showSnackbar"]),
    filterTelephoneCodeAutocompleteBox(item, queryText, itemText) {
      if (
        item.name.toUpperCase().includes(queryText.toUpperCase()) ||
        itemText.toUpperCase().includes(queryText.toUpperCase())
      )
        return true;
      else return false;
    },
    onSave() {
      if (this.$refs.addEditCardHolderForm.validate()) {
        this.cardholder.mobile.replaceAll(" ", "");
        this.editCardholder();
      }
    },
    editCardholder() {
      try {
        updateBusinessCardsDoc(this.cardholder.id, {
            ...this.cardholder,
            countryPhoneCode: this.selectedTelephoneCode.countryCode,
            countryPhoneCodeNumber: this.selectedTelephoneCode.number,
          })
          .then(() => {
            this.closeAddEditCardHolderDialog();
            this.showSnackbar({
              show: true,
              text: "Card holder updated successfully!",
            });
          });
      } catch (error) {
        console.log("Error occurred while updating card holder: ", error);
        this.showSnackbar({
          show: true,
          text: "Error occurred while updating card holder",
        });
      }
    },
    closeAddEditCardHolderDialog() {
      this.editAddDialog = false;
      this.$refs.addEditCardHolderForm.resetValidation();
      this.$emit("close");
    },
  },
};
</script>

<style>
</style>